import { AsyncPortal } from "@circle-react-uikit/AsyncPortal";
import { Loader } from "@circle-react-uikit/Loader";

import { coverImageSelector } from "../constants";

export interface CoverImageLoaderProps {
  isLoading?: boolean;
}

export const CoverImageLoader = ({
  isLoading = true,
}: CoverImageLoaderProps) => {
  if (!isLoading) return null;

  return (
    <AsyncPortal selectorQuery={coverImageSelector}>
      <div className="bg-primary relative h-[30vh]">
        <div
          className="absolute top-0 m-auto flex size-full"
          data-testid="cover-image-loader"
        >
          <Loader center />
        </div>
      </div>
    </AsyncPortal>
  );
};
